<template>
    <span class="fns pr u-us-n" style="display: inline-block;" v-if="uiDisplay">
        <i :class="uiDisplay.cname" :title="uiDisplay.title"></i>
        <i v-if="uiShowNoIntegrationsBadge"
            class="lnr-unlinked hierarchy-icon-badge"
            :title="'mead.labels.no_integrations' | athT">
        </i>
    </span>
</template>

<script>
import CHIERARCHY_TYPES from '@aretheyhappy/lib-taxonomy/company/hierarchy_types';
import { isObject } from '@aretheyhappy/utils';

function M_Display (cname, title) {
    return {cname, title: MeadCommon.I18N.go(title)};
}

export default {
    name: 'mead-location-type',
    props: {
        /**
         * Location/hierarchy object whose `type` (and `is_root` flag) determines the displayed icon and title.
         */
        location: {type: Object, default: () => ({})},
        /**
         * Whether to show a small "no integrations" badge overlaid on the icon.
         */
        uiShowNoIntegrationsBadge: {type: Boolean, default: () => false},
    },
    computed: {
        uiDisplay: function () {
            if (!isObject(this.location)) return false;

            if (this.location.is_root || this.location.type === CHIERARCHY_TYPES.BRAND) {
                return M_Display(
                    `el--t-brand lnr-${MeadCommon.CHIERARCHY_ICONS[CHIERARCHY_TYPES.BRAND]}`,
                    'mead.atom_entity_location_type.brand'
                );
            } else if (this.location.type === CHIERARCHY_TYPES.GROUP) {
                return M_Display(
                    `el--t-group lnr-${MeadCommon.CHIERARCHY_ICONS[CHIERARCHY_TYPES.GROUP]}`,
                    'mead.atom_entity_location_type.group'
                );
            } else if (this.location.type === CHIERARCHY_TYPES.COMPANY) {
                return M_Display(
                    `el--t-company lnr-${MeadCommon.CHIERARCHY_ICONS[CHIERARCHY_TYPES.COMPANY]}`,
                    'mead.atom_entity_location_type.company'
                );
            } else if (this.location.type === CHIERARCHY_TYPES.LABEL) {
                return M_Display(
                    `el--t-label lnr-${MeadCommon.CHIERARCHY_ICONS[CHIERARCHY_TYPES.LABEL]}`,
                    'mead.atom_entity_location_type.label'
                );
            } else {
                return M_Display(
                    `el--t-location lnr-${MeadCommon.CHIERARCHY_ICONS[CHIERARCHY_TYPES.LOCATION]}`,
                    'mead.atom_entity_location_type.location'
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.hierarchy-icon-badge {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.6rem;
    height: 1.6rem;
    font-size: 1.2rem;
    bottom: -.5rem;
    right: -.5rem;
    border-radius: 30%;
}

.lnr-unlinked {
    color: var(--c-txt);
    background-color: var(--c-brand-default-bg);
}
</style>